/** This file contains functions that help to extract data from objects */
import moment from 'moment';
const CALENDAR_FORMAT = {
    lastDay: '[Yesterday]',
    sameDay: '[Today]',
    sameElse: 'MMM D, YYYY'
};

export default {
    getValueByPropertyName,
    getErrorMessage,
    getFormattedNumber,
    getEscapedHtml,
    getPrettyDate
};

/**
 * Returns any nested property of object
 * @param item {Object} {a: {b: {c: 1, d: 2}}}
 * @param property {String} 'a.b.c'
 * @param separator '/' or '.' or any
 * @returns {*} 1 in example
 */
function getValueByPropertyName(item, property, separator) {
    if (!item) {
        return '';
    }
    if (!property) {
        return item;
    }
    let propertyName = property;
    let propertiesComposition = propertyName.split('+');
    if (propertiesComposition.length > 1) {
        // 'a.b.c+a.b.d' return '1 2'
        return getValuesComposition(item, propertyName, separator);
    }
    return getValueRecursively(item, propertyName, separator);
}

function getValuesComposition(item, propertyName, separator) {
    let propertiesArray = propertyName.split('+');
    const values = propertiesArray.map(property => getValueRecursively(item, property, separator));
    return values.filter(value => value).join(' ');
}

function getValueRecursively(item, propertyName, separator) {
    let value = Object.assign({}, item);
    let propertiesArray = propertyName.split(separator || '.');

    propertiesArray.some((property) => {
        value = value[property];
        if (!value) {
            return true;
        }
    });

    return value;
}

/**
 * Try to extract error message from response body.
 * If this was not possible - raise a console error.
 */
function getErrorMessage(response) {
    let message = 'Unexpected error occurred. Please contact support.';
    try {
        if (response.body.detail) message = response.body.detail;
    } catch (e) {
        console.error(e);
    }
    return message;
}

function getFormattedNumber(number, round) {
    if (number === 0) {
        return 0;
    }
    const abbrs = [
        { value: 1, symbol: "" },
        { value: 1E3, symbol: "k" },
        { value: 1E6, symbol: "M" },
        { value: 1E9, symbol: "G" },
        { value: 1E12, symbol: "T" },
        { value: 1E15, symbol: "P" },
        { value: 1E18, symbol: "E" }
    ];
    const regular = /\.0+$|(\.[0-9]*[1-9])0+$/;
    let i = 0;
    for (i = abbrs.length - 1; i > 0; i --) {
        if (number >= abbrs[i].value) {
            break;
        }
    }
    return (number / abbrs[i].value).toFixed(round).replace(regular, "$1") + abbrs[i].symbol;
}

function getEscapedHtml(string) {
    var pre = document.createElement('pre');
    var text = document.createTextNode(string);
    pre.appendChild(text);
    return pre.innerHTML;
}

function getPrettyDate(date) {
    return moment(Date.parse(date)).calendar(null, CALENDAR_FORMAT);
}
